/**
 * Vue3file : Velocity.PrimaryOffersites.Web\wwwroot\js\services\TransactServices\TransactSummaryService.js
 * Make changes there also if you are chanindg this
 */
import Axios from 'axios';
import {
  SUMMARY_PAYMENTDATA,
  SUMMARY_SERVICEPROTECTIONPLAN,
} from '@/js/constants/expresspaymentconstants';
import { ExpressPayments } from '../Payments/ExpressPayments';
import { isHondaAutoData } from '@/js/services/GoogleTagManager/TagManagerConstants';
import { useTradeValuePageStore } from '../../store/TradeValueStore/TradeValuePage/TradeValuePageStore';
import { useKbbWithoutVinStore } from '../../store/TradeValueStore/KbbWithoutVin/KbbWithoutVinStore';
import { useKbbWithVinStore } from '../../store/TradeValueStore/KbbWithVin/KbbWithVinStore';
import { useKbbStore } from '../../store/TradeValueStore/KbbStore/KbbStore';
import { useExpressCheckoutStore } from '../../store/ExpressCheckout/ExpressCheckoutStore/ExpressCheckoutStore';

export function getMonthlyPayment(summaryData, selectedPaymentOption) {
  let payment = 0;
  if (summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]) {
    if ('BasePayment' in summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]) {
      payment = ExpressPayments.ConvertPaymentToNumber(
        summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA].BasePayment
      );
    } else {
      payment = ExpressPayments.ConvertPaymentToNumber(
        summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA].Payment
      );
    }
  }

  let termAmount = 0;
  for (let item of summaryData[selectedPaymentOption.toLowerCase()][
    SUMMARY_SERVICEPROTECTIONPLAN
  ]) {
    if (Number(item.cashPrice)) {
      termAmount += +item.cashPrice;
    }
  }
  let paymentData = summaryData[selectedPaymentOption.toLowerCase()].paymentData;

  let monthlyTerm = 0;

  if (termAmount) {
    monthlyTerm = +termAmount / +paymentData.Term;
  }
  let data = +payment + monthlyTerm;
  return data;
}

export function calculatePaymentWithServiceProtectionPlans(paymentData, serviceProtectionPlans) {
  let payment = 0;

  if ('BasePayment' in paymentData) {
    payment = ExpressPayments.ConvertPaymentToNumber(paymentData.BasePayment);
  } else {
    payment = ExpressPayments.ConvertPaymentToNumber(paymentData.Payment);
  }

  let termAmount = 0;
  for (let item of serviceProtectionPlans) {
    if (Number(item.cashPrice)) {
      termAmount += +item.cashPrice;
    }
  }

  let monthlyTerm = 0;

  if (termAmount) {
    monthlyTerm = +termAmount / +paymentData.Term;
  }
  let data = +payment + monthlyTerm;
  return data;
}

export async function getTransactDeals() {
  return await Axios.get(
    `${window.ApiBaseUrl}/TransactDeals?accountId=${window.accountId}&pin=${
      window.userDetails.userpin
    }&isSavedOffer=true&nocache=true&v=${window.getTimeStamp()}`
  );
}

export async function getTransactDealsByDealId(dealId) {
  return await Axios.get(`${window.ApiBaseUrl}/TransactDeals/GetDealDetails?dealId=${dealId}`);
}

export async function getTransactDealsByVinAndSessionId(vIn, sessionId) {
  return await Axios.get(
    `${
      window.ApiBaseUrl
    }/TransactDeals/GetDealDetailsByVinAndSessionId?vin=${vIn}&SessionId=${sessionId}&v=${window.getTimeStamp()}`
  );
}

export function getTransactTradeDetailsData() {
  const tradeValueStore = useTradeValuePageStore();
  const { vehicledetails, issearchbyvin } = tradeValueStore;
  const { kellyBlueBookWithoutVin } = useKbbWithoutVinStore();
  const { kellyBlueBookWithVin } = useKbbWithVinStore();
  const { kellySelectedVehicleDetails } = useKbbStore();

  const { tradeSelectedOptions, tradeLeaseOptions } = useExpressCheckoutStore();

  let enableKbb = window.enableKbb;

  let tradePayOff = '';

  if (tradeSelectedOptions.type) {
    if (tradeSelectedOptions.type.toLowerCase() === 'leased') {
      if (tradeLeaseOptions.turnLease === 'Turn in my lease early') {
        tradePayOff = +tradeLeaseOptions.monthlyPayments * +tradeLeaseOptions.remainingPayments;
      } else if (tradeLeaseOptions.turnLease === 'Buy out my lease') {
        tradePayOff = tradeLeaseOptions.estimatedLease;
      } else {
        tradePayOff = tradeSelectedOptions.value;
      }
    }

    if (tradeSelectedOptions.type.toLowerCase() === 'financed') {
      tradePayOff = tradeSelectedOptions.value;
    }
  }

  if (!enableKbb) {
    return {
      TradeYear: vehicledetails.year,
      TradeMake: vehicledetails.make,
      TradeModel: vehicledetails.model,
      TradeTrim: vehicledetails.trim,
      TradeMileage: vehicledetails.miles,
      TradeVehicleCondition: vehicledetails.condition,
      TradePayOff: tradePayOff,
    };
  }

  if (issearchbyvin) {
    return {
      TradeVin: kellyBlueBookWithVin.vin,
      TradeMileage: kellyBlueBookWithVin.miles,
      TradeVehicleCondition: kellyBlueBookWithVin.condition,
      TradePayOff: tradePayOff,
      TradeYear: kellySelectedVehicleDetails.yearId,
      TradeMake: kellySelectedVehicleDetails.makeName,
      TradeModel: kellySelectedVehicleDetails.modelName,
      TradeTrim: kellySelectedVehicleDetails.trimName,
      TradeExteriorColor: kellySelectedVehicleDetails.exteriorColor,
    };
  }
  let TradeMake = kellyBlueBookWithoutVin?.selectedMake
    ? kellyBlueBookWithoutVin.selectedMake
    : kellySelectedVehicleDetails?.makeName;
  if (kellyBlueBookWithoutVin?.selectedMakeName) {
    TradeMake = kellyBlueBookWithoutVin.selectedMakeName;
  }

  let TradeModel = kellyBlueBookWithoutVin?.selectedModel
    ? kellyBlueBookWithoutVin.selectedModel
    : kellySelectedVehicleDetails?.modelName;
  if (kellyBlueBookWithoutVin?.selectedModelName) {
    TradeModel = kellyBlueBookWithoutVin.selectedModelName;
  }
  return {
    TradeYear: kellyBlueBookWithoutVin.selectedYear
      ? kellyBlueBookWithoutVin.selectedYear
      : kellySelectedVehicleDetails.yearId,
    TradeMake: TradeMake,
    TradeModel: TradeModel,
    TradeMileage: kellyBlueBookWithoutVin.selectedMiles
      ? kellyBlueBookWithoutVin.selectedMiles
      : kellyBlueBookWithVin.miles,
    TradeTrim: kellyBlueBookWithoutVin.selectedTrimName
      ? kellyBlueBookWithoutVin.selectedTrimName
      : kellySelectedVehicleDetails.trimName,
    TradeExteriorColor: kellyBlueBookWithoutVin.selectedColorName
      ? kellyBlueBookWithoutVin.selectedColorName
      : kellySelectedVehicleDetails.selectedColor,
    TradeVehicleCondition: kellyBlueBookWithoutVin.selectedCondition,
    TradePayOff: tradePayOff,
  };
}

export function sentTradeDetailsProgramme() {
  return (
    window.themeName?.toLowerCase() === 'subaru' ||
    window.themeName?.toLowerCase() === 'toyota' ||
    isHondaAutoData()
  );
}

export function getTotalServiceProtectionPlans(summaryData) {
  let amount = 0;
  try {
    for (let item of summaryData.serviceProtectionPlan) {
      if (Number(item.cashPrice)) {
        amount += item.cashPrice;
      }
    }
  } catch (e) {
    console.log(e);
  }

  return amount;
}
